import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

import Form from './Form';
import Footer from '../common/Footer';
import Header from '../common/Header';
import NavigationCard from './NavigationCard';
import { useToast } from '@chakra-ui/react';

const RedeemGiftCard = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const [username, setUsername] = useState('');

  const [formData, setFormData] = useState({
    Amount: '',
    'Gift Card Code': '',
    'Gift Card Valid Till': '',
  });

  const handleChange = (field) => (e) => {
    setFormData({
      ...formData,
      [field]: e.target.value
    });
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_END_POINT}/transaction/${localStorage.getItem('user_id')}/redeem-gift-card`, {
        amount: formData.Amount,
        type: 'GiftCard',
        code: formData['Gift Card Code'],
        validTill: formData['Gift Card Valid Till'],
      });

      if (response.data?.message) {
        toast({
          title: 'Redeemed Gift Card',
          description: response.data.message,
          status: 'success',
          duration: 3000,
          isClosable: true,
        });

        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else {
        toast({
          title: 'Issue in Redeeming Gift Card',
          description: response.data?.error || '',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error('Error getting URL:', error);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('user-access-token');
    navigate('/user/login');
  }

  useEffect(() => {
    const accessToken = localStorage.getItem('user-access-token');
    setUsername(localStorage.getItem('user_name'));
    if (accessToken) {
      navigate('/user/redeem');
    } else {
      navigate('/user/login');
    }
  }, []);

  return (
    <div>
      <Header
        handleLogout={handleLogout}
      />

      <Form
        title={'Redeem Gift Card'}
        description={`Welcome Back ${username}`}
        fields={['Amount', 'Gift Card Code', 'Gift Card Valid Till']}
        fieldValues={formData}
        handleSubmit={handleSubmit}
        handleChange={handleChange}
        suggestedAmount={['$ 20', '$ 50', '$ 100', '$ 200', '$ 500', '$ 1000']}
      />

      <div className='navigation-cards-container'>
        <NavigationCard title='Purchase Electricity' navigationUrl='/user/electricity' />
        <NavigationCard title='Purchase Gift Card' navigationUrl='/user/giftcard' />
      </div>

      <Footer />
    </div>
  );
}

export default RedeemGiftCard;
